import { makeStyles } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Clipboard from "@saleor/components/Clipboard";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import { CouponCollectionFormData } from "@saleor/utils/validators/couponCollection";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  {
    cardTitle: {
      "& span": {
        fontWeight: "bold"
      }
    },
    isHidden: {
      "& span": {
        fontSize: "15px"
      },
      marginBottom: "10px",
      marginLeft: "12px",
      marginTop: "10px"
    },
    line: {
      margin: "auto",
      width: "88%"
    }
  },
  { name: "CouponCollectionDeepLinkDetails" }
);
export interface DeepLinkProps {
  data: CouponCollectionFormData;
  disabled: boolean;
  linkId: string;
  linkUrl: string;
  shortLinkUrl: string;
  onGenerateDeeplink: (id: string) => void;
  onChange(event: any);
}

const DeepLink: React.FC<DeepLinkProps> = ({
  data,
  disabled,
  onChange,
  linkId,
  shortLinkUrl,
  onGenerateDeeplink
}) => {
  const intl = useIntl();
  const classes = useStyles({});

  return (
    <Card>
      <CardTitle className={classes.cardTitle} title="Deeplink Details" />
      <ControlledCheckbox
        id="isHiddenCheckbox"
        name="isHidden"
        checked={data.isHidden}
        label={intl.formatMessage({
          defaultMessage: "The coupon collection will only be accessed via link"
        })}
        className={classes.isHidden}
        disabled={disabled}
        onChange={onChange}
      />
      <Hr className={classes.line} />
      <CardContent>
        <Clipboard
          idClipboard="couponCollectionID"
          label="Collection ID"
          value={encodeURIComponent(linkId)}
          onGenerate={() => undefined}
        />
        <FormSpacer />
        <Clipboard
          idClipboard="shortDynamicURL"
          label="Short Dynamic URL"
          value={shortLinkUrl}
          onGenerate={() => onGenerateDeeplink(linkId)}
        />
      </CardContent>
    </Card>
  );
};

export default DeepLink;
